import React from "react";

import { faPencil } from "@fortawesome/pro-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";

import { ACTION_COLUMN_NAME } from "constants/aggrid";
import { MultiButton, SlimButton } from "components/Button";

import { ColDef, ICellRendererParams } from "ag-grid-community";
import { openModalLink } from "lib/navigation";
import { ModalTypes } from "constants/navigation";
import { hasPermission } from "lib/permissions";
import { SaleStatusPermissions } from "constants/permissions";

export const SaleStatusColId = {
  NAME: "3755dd62-ecda-473a-abc7-d43efb6d905c",
  ARCHETYPE: "59752e29-cd27-4880-a152-851c097f0ee2",
  SALE_TYPE: "58877a31-fdf0-460d-9a3f-36a53c509b69",
  ACTIONS: "ed889b66-aab6-4724-9eae-dda61be9a9aa",
} as const;

const ActionRenderer = ({ data }: ICellRendererParams) => {
  if (!data) {
    return null;
  }

  const { id } = data || {};

  function onClickEdit() {
    openModalLink(ModalTypes.SaleStatus, {
      id,
    });
  }

  const readOnly = !hasPermission(data, SaleStatusPermissions.update);

  const buttons = [
    {
      dataTour: "editSaleStatus",
      default: false,
      icon: readOnly ? faEye : faPencil,
      isDisabled: false,
      onClick: onClickEdit,
      title: readOnly ? "View" : "Edit",
      tooltip: `${readOnly ? "View" : "Edit"} the Sale Status`,
    },
  ];

  return <MultiButton buttons={buttons} ButtonComponent={SlimButton} />;
};

export type SaleStatusAgGridRowType = Record<
  ValueInObj<typeof SaleStatusColId>,
  ColDef<SaleStatus>
>;

export const SaleStatusColumnDef: SaleStatusAgGridRowType = {
  [SaleStatusColId.NAME]: {
    colId: SaleStatusColId.NAME,
    headerName: "Name",
    field: "name",
  },
  [SaleStatusColId.ARCHETYPE]: {
    colId: SaleStatusColId.ARCHETYPE,
    headerName: "Base",
    field: "archetype",
    enableRowGroup: true,
  },
  [SaleStatusColId.SALE_TYPE]: {
    colId: SaleStatusColId.SALE_TYPE,
    headerName: "Sale Type",
    field: "saleType",
    enableRowGroup: true,
  },
  [SaleStatusColId.ACTIONS]: {
    colId: SaleStatusColId.ACTIONS,
    headerName: ACTION_COLUMN_NAME,
    pinned: "right",
    cellRenderer: ActionRenderer,
    width: 100,
  },
};
